export const handleGetDayProps = (dateString: string) => {
    const date = new Date(dateString);
    return {
        'aria-label': `Select date ${date.getUTCMonth() + 1}/${date.getUTCDate()}/${date.getUTCFullYear()}`,
    };
};

export const handleGetYearControlProps = (dateString: string) => {
    const date = new Date(dateString);
    return {
        'aria-label': `Select year ${date.getUTCFullYear()}`,
    };
};

export const handleGetMonthControlProps = (dateString: string) => {
    const date = new Date(dateString);
    return {
        'aria-label': `Select month ${date.getUTCFullYear()}/${date.getUTCMonth()}`,
    };
};
